import {gql} from '@apollo/client'

export const ADD_TO_RECIPIENTS = gql`
  mutation AddToRecipients($contactIds: [ID!]!) {
    addToRecipients(contactIds: $contactIds) {
      ok
      addedCount
    }
  }
`

export const REMOVE_FROM_RECIPIENTS = gql`
  mutation RemoveFromRecipients($contactIds: [ID!]!) {
    removeFromRecipients(contactIds: $contactIds) {
      ok
      removedCount
    }
  }
`

export const GET_RECIPIENT_STATS = gql`
  query GetRecipientStats {
    recipientStats {
      totalRecipients
      subscribedCount
      unsubscribedCount
    }
  }
`

